module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('control', {
    attrs: {
      "label": 'Head of Loss ' + (_vm.index + 1),
      "for": "name"
    }
  }, [_c('input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    attrs: {
      "autocomplete": "off",
      "name": "name",
      "placeholder": "Type of Head of Loss",
      "required": ""
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }, _vm.updateValid]
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('name')
    }
  }, [_vm._v("\n            Type of loss is required\n        ")])], 1), _vm._v(" "), _c('control', {
    attrs: {
      "for": "value",
      "before-after": "pound"
    }
  }, [_c('input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }, {
      name: "model",
      rawName: "v-model.number",
      value: (_vm.value),
      expression: "value",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "autocomplete": "off",
      "name": "value",
      "required": "",
      "min": "1",
      "type": "number"
    },
    domProps: {
      "value": (_vm.value)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.value = _vm._n($event.target.value)
      }, _vm.updateValid],
      "focus": function($event) {
        _vm.value = _vm.value || ''
      },
      "blur": [function($event) {
        _vm.value = _vm.value || 0
      }, function($event) {
        return _vm.$forceUpdate()
      }]
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('value')
    }
  }, [_vm._v("\n            Value should be greater than £0.00\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "a-button",
    on: {
      "click": _vm.deleteThisHeadOfLoss
    }
  }, [_vm._v("Delete Head of Loss")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-59032d3f!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/personal-injury-claims/steps/heads-of-loss/HeadOfLoss.vue
// module id = 1705
// module chunks = 0